<script setup lang="ts">
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

const { faqs } = useLandingData()
</script>

<template>
  <section id="faq" class="container mx-auto mt-[80px] px-4">
    <h2 class="text-[32px] md:text-[42px] font-medium text-neutral-800">
      Frequently
      <br class="hidden md:block">
      asked questions
    </h2>
    <p class="mt-4 text-lg font-normal text-neutral-600 geistMonoFont">
      Kami di sini untuk membantu dengan pertanyaan
      <br class="hidden md:block">
      apa pun yang Anda miliki tentang paket, harga,
      <br class="hidden md:block">
      penagihan, pencairan, dan fitur yang didukung.
    </p>

    <ClientOnly>
      <Accordion
        type="multiple"
        class="mt-7.5 sm:mt-16 mb-7.5 sm:mb-20 space-y-4"
        collapsible
      >
        <AccordionItem
          v-for="(faq, index) in faqs"
          :key="index"
          :value="`item-${index}`"
          class="border border-neutral-200 rounded-md px-4 py-0 last:border-b"
        >
          <AccordionTrigger icon-type="plusMinus" icon-size="lg" class="text-[15px] text-left font-normal text-neutral-700 hover:no-underline geistMonoFont">
            {{ faq.question }}
          </AccordionTrigger>
          <AccordionContent class="text-base text-neutral-600 geistMonoFont faq-content">
            <div v-html="faq.answer" />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </ClientOnly>
  </section>
</template>

<style scoped>
.faq-content :deep(p) {
  margin-bottom: 0;
  line-height: 1.6;
}

.faq-content :deep(p + p) {
  margin-top: 1rem;
}

.faq-content :deep(ol) {
  margin-top: 0;
  margin-bottom: 0;
}

.faq-content :deep(li) {
  margin-bottom: 1rem;
  line-height: 1.6;
}

.faq-content :deep(li:last-child) {
  margin-bottom: 0;
}

.faq-content :deep(a) {
  color: #2563eb;
  text-decoration: none;
}

.faq-content :deep(a:hover) {
  text-decoration: underline;
}

.faq-content :deep(strong) {
  font-weight: 600;
  color: #374151;
}
</style>
